import { render, staticRenderFns } from "./CustomerGroupsTable.vue?vue&type=template&id=3a6dd21b"
import script from "./CustomerGroupsTable.vue?vue&type=script&lang=js"
export * from "./CustomerGroupsTable.vue?vue&type=script&lang=js"
import style0 from "./CustomerGroupsTable.vue?vue&type=style&index=0&id=3a6dd21b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports